import React from 'react'
import { List, ExpandableListItem, ListItem, BillboardText, colors } from '@fs/zion-ui'
import { HelpTip } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

export default function Tip({
  useOverline = true,
  iconColor = colors.gray90,
  overline,
  primaryText,
  initiallyOpen,
  listOverline,
  listPrimaryText,
  listSecondaryText,
}) {
  const [t] = useTranslation()
  return (
    <List>
      <ExpandableListItem
        overline={useOverline && (overline || t('full-name-corrections.question', 'QUESTION'))}
        primaryText={<BillboardText>{primaryText}</BillboardText>}
        initiallyOpen={initiallyOpen}
        startElement={<ListItem.Icon Icon={HelpTip} color={iconColor} />}
      >
        <ListItem overline={listOverline} primaryText={listPrimaryText} secondaryText={listSecondaryText} />
      </ExpandableListItem>
    </List>
  )
}
